import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { CirclePicker } from 'react-color';
import Loader from '../../../commons/loader';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from '../services';
import { PaginationTotal } from '../../../commons/controls';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import NumberFormatter from '../../../commons/NumberFormatter';
import SlaveAvInput from '../../../commons/SlaveAvInput';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import Lib from '../../../commons/lib';

class KozosCsoportLista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bufeKozosCsoportJson: [],
      bufek: [],
      bufe: null,
      bufeTermek: null,
      cikkek: [],
      cikk: null,
      currentKozosCsoport: {},
      currentRow: [],
      currentColor: '',
      dataLoaded: false,
      dataFailed: false,
      dataEmpty: false,
      dataKozosTermekLoaded: false,
      loading: false,
      modalKozosCsoport: false,
      modalKozosCsoportModosit: false,
      modalKozosCsoportTorles: false,
      modalKozosTermek: false,
      modalKozosTermekModosit: false,
      modalKozosTermekTorles: false,
      selectedKozosTermekek: [],
      kozosCsoportModositObj: {},
      kozosTermekListJson: [],
      kozosTermekModositObj: {},
      formTermekAzonosito: null,
      formTermekNev: null,
      defaultCurrencyAzon: null,
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
    this.addKozosTermek = this.addKozosTermek.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.getDefaultCurrency();
        this.updateTable();
        this.setState({ bufe: null, bufeTermek: null });
      }
    }
  } 

  getDefaultCurrency = () => {
    Service.getDefaultCurrency((err, res) => {
      if (!err) {
        this.setState({ defaultCurrencyAzon: res[0].azonosito });
      } else {
        this.setState({ defaultCurrencyAzon: '' });
      }
    });
  }

  onRowSelect(row) {
    this.listBufekSelect();
    this.setState({
      currentKozosCsoport: row, currentRow: [row.id], bufe: null, bufeTermek: null, selectedKozosTermekek: []
    });
    this.updateKozosTermekTable(row.id);
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['BUFE_KOZOS'], true);
  }

  szinValaszto = () => {
    return (
      <div className="row">
        <div className="col-md-2" />
        <div className="col-md-8">
          <CirclePicker color={this.state.currentColor} onChangeComplete={this.handleColorChange} colors={["#607d8b", "#795548", "#9c27b0", "#baaaff", "#3f51b5", "#2196f3", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#16ed75", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#f44336", "#e91e63"]} />
        </div>
        <div className="col-md-2" />
      </div>
    );
  }

  cikkValaszto = () => {
    return (
      <SelectField
        name="cikkvalaszto"
        id="cikkvalaszto"
        noOptionsMessage={() => 'Nincs keresési eredmény'}
        searchPromptText="Kezdj el gépelni a kereséshez..."
        placeholder="Keresés megnevezés alapján..."
        loadingMessage={() => 'Keresés...'}
        isClearable
        ignoreAccents={false}
        isLoading={this.state.loading}
        onInputChange={_.debounce(this.handleInputChangeCikk, 1000)}
        onChange={this.handleCikkChange}
        options={this.state.cikkek}
        getOptionLabel={option => option.megnevezes}
        getOptionValue={option => option}
      />
    );
  }

  bufeValaszto = (termek_e, bufeValue) => {
    return (
      <SelectField
        name="bufevalaszto"
        id="bufevalaszto"
        placeholder="Válassz büfét..."
        noOptionsMessage={() => 'Nincs választható büfé'}
        loadingMessage={() => 'Keresés...'}
        isClearable
        menuPlacement="auto"
        ignoreAccents={false}
        isLoading={false}
        onChange={(bufe) => {
          if (termek_e) {
            this.setState({ bufeTermek: bufe });
          } else {
            this.setState({ bufe: bufe });
          }
        }}
        value={bufeValue}
        options={this.state.bufek}
        getOptionLabel={option => option.nev}
        getOptionValue={option => option}
      />
    );
  }

  /** Táblázat adatainak frissítése adatbázisból. */
  updateTable = () => {
    this.setState({
      dataLoaded: false,
      dataFailed: false,
      dataEmpty: false,
    });
    Service.listKozosCsoport((err, res) => {
      if (!err) {
        res[0].forEach((element) => {
          element.szinkod = '#' + element.szinkod;
        });
        this.setState({ bufeKozosCsoportJson: res[0], dataLoaded: true, dataFailed: false, dataEmpty: res[0].length === 0 });
      } else {
        this.setState({
          dataLoaded: false, dataFailed: true, dataEmpty: false
        });
      }
    });
  }

  termekMasolasGomb = () => {
    if (this.state.selectedKozosTermekek.length !== 0)
      return <Button className="margin-top-30" color="success">Másolás</Button>;
    return <Button className="margin-top-30 bg-secondary text-white" disabled>Másolás</Button>;
  }

  checkListaar = (listaar) => {
    if (listaar < 0 || listaar == "-0" || isNaN(listaar)) {
      this.props.globals.addError('A listaár csak természetes szám lehet!');
      return false;
    }
    return true;
  }

  checkSzinkod = (szinkod) => {
    if (szinkod.length !== 7) {
      this.props.globals.addError('A szín megadása kötelező!');
      return false;
    }
    return true;
  }

  checkKozosCsoportNev = (kozosCsoportNev) => {
    if (kozosCsoportNev.length > 30) {
      this.props.globals.addError('A termékcsoport neve maximum 30 karakter lehet!');
      return false;
    }
    return true;
  }

  checkKozosTermekNev = (kozosTermekNev) => {
    if (kozosTermekNev.length > 20) {
      this.props.globals.addError('A termék rövid neve maximum 20 karakter lehet!');
      return false;
    }
    return true;
  }

  checkCikk = () => {
    if (!this.state.cikk) {
      this.props.globals.addError('Cikk választása kötelező!');
      return false;
    }
    return true;
  }

  /** Új termékcsoport felviteli modal kapcsolása. */
  toggleKozosCsoport = () => {
    this.setState((prevState) => { return ({ modalKozosCsoport: !prevState.modalKozosCsoport, currentColor: '' }); });
  }

  /** Termékcsoport módosító modal. */
  toggleKozosCsoportModosit = () => {
    this.setState((prevState) => { return ({ modalKozosCsoportModosit: !prevState.modalKozosCsoportModosit }); });
  }

  /** Meglévő termékcsoport törlés megerősítő modal kapcsolása. */
  toggleKozosCsoportTorles = () => {
    this.setState((prevState) => { return ({ modalKozosCsoportTorles: !prevState.modalKozosCsoportTorles }); });
  }

  /** Új termék felviteli modal kapcsolása. */
  toggleKozosTermek = () => {
    this.setState((prevState) => {
      return ({
        modalKozosTermek: !prevState.modalKozosTermek, currentColor: '', cikk: null, cikkek: [], formTermekAzonosito: null, formTermekNev: null
      });
    });
  }

  /** Termék módosító modal. */
  toggleKozosTermekModosit = () => {
    delete this.state.kozosTermekModositObj.megnevezes;
    this.setState((prevState) => { return ({ modalKozosTermekModosit: !prevState.modalKozosTermekModosit, cikkek: [], formTermekAzonosito: null, formTermekNev: null }); });
  }

  /** Meglévő termék törlés megerősítő modal kapcsolása. */
  toggleKozosTermekTorles = () => {
    this.setState((prevState) => { return ({ modalKozosTermekTorles: !prevState.modalKozosTermekTorles }); });
  }

  handleKozosCsoportEditClick = (id) => {
    this.setState((prevState) => {
      const kozosCsoport = prevState.bufeKozosCsoportJson.find(element => element.id === id);
      return ({ kozosCsoportModositObj: kozosCsoport, currentColor: kozosCsoport.szinkod });
    });
    this.toggleKozosCsoportModosit();
  }

  handleKozosCsoportDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleKozosCsoportTorles();
  }

  /**
   * Átmásolja a kiválasztott közöscsoportot és az összes hozzátartozó terméket a kiválasztott helyi büfébe.
   */
  handleKozosCsoportMasolas = () => {
    if (this.isEmpty(this.state.bufe)) {
      this.props.globals.addError('Termékcsoport másoláshoz ki kell választani egy büfét!');
    } else {
      let bean = {};
      bean.bufeid = this.state.bufe.id;
      bean.termekcsoportid = this.state.currentKozosCsoport.id;

      if (this.state.kozosTermekListJson.length !== 0) {
        bean.termekids = this.state.kozosTermekListJson.map(x => x.id);
      }

      Service.masolBufeTermekCsoport(bean, (err, res) => {
        if (!err) {
          if (res[0].toString() === 'false') this.props.globals.addSuccess('Termékcsoport frissítve!')
          else this.props.globals.addSuccess('Termékcsoport átmásolva!');
        }
      });
    }
  }

  handleKozosTermekDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleKozosTermekTorles();
  }

  handleKozosTermekEditClick = (id) => {
    let kozosTermek = Object.assign({}, this.state.kozosTermekListJson.find(element => element.id === id));
    let cikk = {};
    Service.getCikk(kozosTermek.cikkid, (err, res) => {
      if (!err) {
        kozosTermek.megnevezes = res[0].megnevezes;
        cikk = res[0];
      }
      kozosTermek.listaar = kozosTermek.listaar.slice(0, -3);
      this.setState({ kozosTermekModositObj: kozosTermek, currentColor: kozosTermek.szinkod, cikk: cikk }, () => {
        this.toggleKozosTermekModosit();
      });
    });
  }

  /**
   * Átmásolja a kiválasztott közösterméke(ke)t és a hozzátartozó közöscsoportot a kiválasztott helyi büfébe
   */
  handleKozosTermekMasolas = () => {
    if (this.isEmpty(this.state.bufeTermek)) {
      this.props.globals.addError('A termék másoláshoz ki kell választani egy büfét!');
    } else {
      let bean = {};
      bean.bufeid = this.state.bufeTermek.id;
      bean.termekcsoportid = this.state.currentKozosCsoport.id;

      if (this.state.selectedKozosTermekek.length !== 0) {
        bean.termekids = this.state.selectedKozosTermekek.map(x => x.id);
      }

      Service.masolBufeTermekCsoport(bean, (err, res) => {
        if (!err) {
          if (res[0].toString() === 'false') this.props.globals.addSuccess('Termékek frissítve!')
          else this.props.globals.addSuccess('Termékek átmásolva!');
        }
      });
    }
  }

  handleColorChange = (color) => {
    this.setState({ currentColor: color.hex });
  }

  handleCikkChange = (cikk) => {
    if (cikk) {
      this.setState({
        cikk: cikk,
        formTermekAzonosito: cikk.cikkszam.substring(0, 15),
        formTermekNev: cikk.megnevezes.substring(0, 25)
      });
    } else {
      this.setState({ cikk: null });
    }
  }

  handleInputChangeCikk = (value, { action }) => {
    switch (action) {
      case 'input-change':
        if (value && value.length > 2) {
          this.setState({ loading: true });
          Service.getAktivCikkek(value, (err, res) => {
            if (!err) {
              this.setState({
                cikkek: res[0],
                loading: false
              });
            }
          });
        }
        break;
      default:
    }
  }

  handleTermekSelect = (row, isSelect) => {
    if (isSelect) {
      this.setState((prevState) => { return { selectedKozosTermekek: [...prevState.selectedKozosTermekek, row] }; });
    } else {
      this.setState((prevState) => {
        return ({ selectedKozosTermekek: prevState.selectedKozosTermekek.filter(element => element !== row) });
      });
    }
  }

  /**
  * Visszaadja a termékcsoporthoz tartozó művelet gombokat.
  * @param {string} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Módosítás, törlés gombokat tartalmazó react objektum.
  */
  iconFormatter = (cell) => {
    return (
      <div>
        <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleKozosCsoportEditClick(cell)} />
        <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleKozosCsoportDeleteClick(cell)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
      </div>
    );
  }

  /**
  * Visszaadja a termékhez tartozó művelet gombokat.
  * @param {string} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Módosítás, törlés gombokat tartalmazó react objektum.
  */
  iconFormatterKozosTermek = (cell) => {
    return (
      <div>
        <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleKozosTermekEditClick(cell)} />
        <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleKozosTermekDeleteClick(cell)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
      </div>
    );
  }

  /**
  * Paraméterként kapott termékcsoport objektum felvétele adatbázisba.
  * @param {SytheticEvent} event
  * @param {object} kozosCsoportObj Termékcsoport adatokat tartalamzó objektum.
  */
  addKozosCsoport = (event, kozosCsoportObj) => {
    kozosCsoportObj.szinkod = this.state.currentColor;
    if (this.checkKozosCsoportNev(kozosCsoportObj.nev) && this.checkSzinkod(kozosCsoportObj.szinkod)) {
      if (kozosCsoportObj.szinkod.length > 6)
        kozosCsoportObj.szinkod = kozosCsoportObj.szinkod.substr(1, 6);
      Service.addKozosCsoport(kozosCsoportObj, (err) => {
        if (!err) {
          this.toggleKozosCsoport();
          this.updateTable();
          this.props.globals.addSuccess('Termékcsoport hozzáadva!');
        }
      });
    }
  }

  /**
  * Törli az adott termékcsoportot.
  */
  deleteKozosCsoport = () => {
    this.toggleKozosCsoportTorles();
    Service.deleteKozosCsoport(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.setState({ currentKozosCsoport: {}, currentRow: [] });
        this.props.globals.addSuccess('Termékcsoport törölve!');
      }
    });
  }

  /**
  * Paraméterként kapott termékcsoport objektum módosítása adatbázisban.
  * @param {SytheticEvent} event
  * @param {object} kozosCsoportModositObj Termékcsoport adatokat tartalamzó objektum.
  */
  modifyKozosCsoport = (event, kozosCsoportModositObj) => {
    kozosCsoportModositObj.szinkod = this.state.currentColor;
    if (this.checkKozosCsoportNev(kozosCsoportModositObj.nev) && this.checkSzinkod(kozosCsoportModositObj.szinkod)) {
      this.state.kozosCsoportModositObj.nev = kozosCsoportModositObj.nev;
      if (kozosCsoportModositObj.szinkod.length > 6)
        this.state.kozosCsoportModositObj.szinkod = kozosCsoportModositObj.szinkod.substr(1, 6);
      else this.state.kozosCsoportModositObj.szinkod = kozosCsoportModositObj.szinkod;
      this.state.kozosCsoportModositObj.azonosito = kozosCsoportModositObj.azonosito;
      Service.editKozosCsoport(this.state.kozosCsoportModositObj, (err) => {
        this.updateTable();
        if (!err) {
          this.toggleKozosCsoportModosit();
          this.props.globals.addSuccess('Termékcsoport módosítva!');
        }
      });
    }
  }



  addKozosTermek = (event, kozosTermekObj) => {
    kozosTermekObj.kozoscsoportid = this.state.currentKozosCsoport.id;
    kozosTermekObj.szinkod = this.state.currentColor;
    kozosTermekObj.listaar = NumberFormatter.removeSpacesFromString(kozosTermekObj.listaar);
    if (this.checkKozosTermekNev(kozosTermekObj.rovidnev) && this.checkSzinkod(kozosTermekObj.szinkod) && this.checkListaar(kozosTermekObj.listaar) && this.checkCikk()) {
      kozosTermekObj.cikkid = this.state.cikk.id;
      if (kozosTermekObj.szinkod.length > 6)
        kozosTermekObj.szinkod = kozosTermekObj.szinkod.substr(1, 6);
      Service.addKozosTermek(kozosTermekObj, (err) => {
        if (!err) {
          this.toggleKozosTermek();
          this.updateKozosTermekTable();
          this.props.globals.addSuccess('Termék hozzáadva!');
        }
      });
    }

  }

  modifyKozosTermek = (event, kozosTermekModositObj) => {
    kozosTermekModositObj.szinkod = this.state.currentColor;
    kozosTermekModositObj.listaar = NumberFormatter.removeSpacesFromString(kozosTermekModositObj.listaar);
    if (this.checkKozosTermekNev(kozosTermekModositObj.rovidnev) && this.checkSzinkod(kozosTermekModositObj.szinkod) && this.checkListaar(kozosTermekModositObj.listaar)) {
      this.state.kozosTermekModositObj.rovidnev = kozosTermekModositObj.rovidnev;
      if (kozosTermekModositObj.szinkod.length > 6)
        this.state.kozosTermekModositObj.szinkod = kozosTermekModositObj.szinkod.substr(1, 6);
      else
        this.state.kozosTermekModositObj.szinkod = kozosTermekModositObj.szinkod;
      this.state.kozosTermekModositObj.listaar = kozosTermekModositObj.listaar;
      Service.editKozosTermek(this.state.kozosTermekModositObj, (err) => {
        this.updateKozosTermekTable();
        if (!err) {
          this.toggleKozosTermekModosit();
          this.props.globals.addSuccess('Termék módosítva!');
        }
      });
    }
  }

  deleteKozosTermek = () => {
    this.toggleKozosTermekTorles();
    Service.deleteKozosTermek(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateKozosTermekTable();
        this.props.globals.addSuccess('Termék törölve!');
      }
    });
  }

  updateKozosTermekTable = (id) => {
    this.setState({ dataKozosTermekLoaded: false });
    Service.listKozosTermek(id || this.state.currentKozosCsoport.id, (err, res) => {
      if (!err) {
        res[0].forEach((element) => {
          element.szinkod = '#' + element.szinkod;
          element.listaar = NumberFormatter.addSpacesToString(element.listaar, NumberFormatter.OSSZEG) + ' ' + this.state.defaultCurrencyAzon;
        });
        this.setState({ kozosTermekListJson: res[0], dataKozosTermekLoaded: true });
      }
    });
  }

  listBufekSelect = () => {
    Service.listBufekSelect((err, res) => {
      if (!err) {
        const options = res[0];
        this.setState({
          bufek: options
        });

        if(options.length === 1) {
          if(!this.state.bufeTermek) {
            this.setState({ bufeTermek: options[0] });
          }

          if(!this.state.bufe) {
            this.setState({ bufe: options[0] });
          }
        }
      }
    });
  }

  isEmpty = (obj) => {
    for (var key in obj)
      if (obj.hasOwnProperty(key)) return false;
    return true;
  }

  styleSzinkod = (szinkod) => {
    return {
      whiteSpace: 'pre-line',
      backgroundColor: szinkod
    };
  }

  renderTable = () => {
    let selectRowProp = {
      mode: 'radio',
      onSelect: this.onRowSelect,
      selected: this.state.currentRow
    };

    const columns = [
      {
        dataField: 'nev',
        text: 'Termékcsoport',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'szinkod',
        text: 'Színkód',
        style: this.styleSzinkod,
        formatter: () => { return '' },
        sort: true
      },
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      }
    ];

    const columns2 = [
      ...columns,
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.bufeKozosCsoportJson}
        columns={this.hasRoleKarb() ? columns2 : columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
        selectRow={selectRowProp}
      />
    );
  }

  renderKozosTermekTabla = () => {
    let selectRowProp = {
      mode: 'checkbox',
      hideSelectAll: true,
      onSelect: this.handleTermekSelect,
      selected: this.state.selectedKozosTermekek.map((element) => { return element.id; })
    };

    const columns = [
      {
        dataField: 'rovidnev',
        text: 'Termék neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'cikkmegnevezes',
        text: 'Cikk neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'szinkod',
        text: 'Színkód',
        style: this.styleSzinkod,
        formatter: () => { return '' },
        sort: true
      },
      {
        dataField: 'listaar',
        text: 'Listaár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlign,
        sort: true,
        sortFunc: (a, b, order) => {
          a = a.slice(0, -2);
          b = b.slice(0, -2);
          if (order === 'asc') {
            return a - b;
          }
          return b - a;
        }
      },
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },

    ];

    const columns2 = [
      ...columns,
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatterKozosTermek
      }
    ];

    let masolasGombKozosCsoport;
    let masolasGombKozosTermek;
    let kozostermekgomb = <p />;
    let kozostermektabla;

    if (!this.isEmpty(this.state.currentKozosCsoport)) {
      masolasGombKozosCsoport = (
        <div>
          <div className="row">
            <div className="col-md-12">
              <RFForm
                onSubmit={this.handleKozosCsoportMasolas}
              >
                <div>
                  <div className="row">
                    <div className="col-md-3">
                      <Label>Kijelölt csoport másolása ide:</Label>
                      {this.bufeValaszto(false, this.state.bufe)}
                    </div>
                    <div className="col-md-3">
                      <Button className="margin-top-30" color="success">Másolás</Button>
                    </div>
                  </div>
                </div>
              </RFForm>
            </div>
          </div>
        </div>
      );

      masolasGombKozosTermek = (
        <div>
          <div className="row">
            <div className="col-md-12">
              <RFForm onSubmit={this.handleKozosTermekMasolas}>
                <div>
                  <div className="row">
                    <div className="col-md-3">
                      <Label>Kijelölt termék(ek) másolása ide:</Label>
                      {this.bufeValaszto(true, this.state.bufeTermek)}
                    </div>
                    <div className="col-md-3">
                      {this.termekMasolasGomb()}
                    </div>
                  </div>
                </div>
              </RFForm>
            </div>
          </div>
        </div>
      );

      kozostermekgomb = (
        <div className="row">
          {
            this.hasRoleKarb()
              ? (
                <div className="col-sm-12" style={{ marginTop: '15px' }}>
                  <Button className="pull-left table-new-button" color="primary" onClick={this.toggleKozosTermek}>Új termék</Button>
                </div>
              )
              : <div />
          }
        </div>
      );
      kozostermektabla = !this.isEmpty(this.state.kozosTermekListJson) ? (
        <BootstrapTable2
          bootstrap4
          keyField="id"
          data={this.state.kozosTermekListJson}
          columns={this.hasRoleKarb() ? columns2 : columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          selectRow={selectRowProp}
        />
      ) : <DataEmptyState hasImage />;
    }

    return (
      <div>
        {masolasGombKozosCsoport}
        {kozostermekgomb}
        {kozostermektabla}
        {!this.isEmpty(this.state.kozosTermekListJson) ? masolasGombKozosTermek : <div />}
      </div>
    );
  }

  /**
   * React render.
   * @return {ReactElement} Termékcsoport modul.
   */
  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="row">
          {
            this.hasRoleKarb()
              ? (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.toggleKozosCsoport}>Új termékcsoport</Button>
                </div>
              )
              : <div />
          }
        </div>
        {this.state.dataFailed ? <NetworkEmptyState hasImage submitClick={this.updateTable} /> : (this.state.dataEmpty) ? <DataEmptyState hasImage subtitle="Vigyél fel új tételt!" /> : (this.state.dataLoaded && !this.state.dataFailed) ? this.renderTable() : <Loader />}
        {this.state.dataKozosTermekLoaded ? this.renderKozosTermekTabla() : <div />}
        <RFForm
          onSubmit={this.addKozosCsoport}
          modalInsert
          title={'Termékcsoport felvétel1'}
          tagProps={{ isOpen: this.state.modalKozosCsoport, toggle: this.toggleKozosCsoport, className: this.props.className, backdrop: 'static' }}
          footer={
            <>
              <Button color="primary">Mentés</Button>{' '}
              <Button type="button" color="secondary" onClick={this.toggleKozosCsoport}>Mégsem</Button>
            </>
          }
        >
          <div>
            <Label for="azonosito">Azonosító: *</Label>
            <RFField
              name="azonosito"
              id="azonosito"
              // validate={{
              //   maxLength: { value: 15 }
              // }}
              maxLength={15}
              required
            />
          </div>
          <div>
            <Label for="nev">Termékcsoport neve: *</Label>
            <RFField
              name="nev"
              id="nev"
              // validate={{
              //   maxLength: { value: 30 }
              // }}
              maxLength={30}
              required
            />
          </div>
          <div>
            <Label for="szinkod">Színválasztás*</Label>
            {this.szinValaszto()}
          </div>
        </RFForm>
        <RFForm
          onSubmit={this.modifyKozosCsoport}
          modalInsert
          title={'Termékcsoport módosítás'}
          tagProps={{ isOpen: this.state.modalKozosCsoportModosit, toggle: this.toggleKozosCsoportModosit, className: this.props.className, backdrop: 'static' }}
          footer={
            <>
              <Button className="btn-cursor-pointer" color="primary">Mentés</Button>{' '}
              <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleKozosCsoportModosit}>Mégsem</Button>
            </>
          }
        >
          <div>
            <Label for="azonosito">Azonosító: </Label>
            <RFField
              name="azonosito"
              id="azonosito"
              value={this.state.kozosCsoportModositObj.azonosito}
              disabled
            />
          </div>
          <div>
            <Label for="nev">Termékcsoport neve: *</Label>
            <RFField
              name="nev"
              id="nev"
              value={this.state.kozosCsoportModositObj.nev}
              // validate={{
              //   maxLength: { value: 30 }
              // }}
              maxLength={30}
              required
            />
          </div>
          <div>
            <Label for="szinkod">Szín: *</Label>
            {this.szinValaszto()}
          </div>
        </RFForm>
        <Modal isOpen={this.state.modalKozosCsoportTorles} toggle={this.toggleKozosCsoportTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a termékcsoportot?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteKozosCsoport}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleKozosCsoportTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <RFForm
          onSubmit={this.addKozosTermek}
          modalInsert
          title={'Termék felvétel'}
          tagProps={{ isOpen: this.state.modalKozosTermek, toggle: this.toggleKozosTermek, className: this.props.className, backdrop: 'static' }}
          footer={
            <>
              <Button color="primary">Mentés</Button>{' '}
              <Button type="button" color="secondary" onClick={this.toggleKozosTermek}>Mégsem</Button>
            </>
          }
        >
            <div>
              <div className="row">
                <div className="col-md-10">
                  <div>
                    <Label for="cikk">Cikk: *</Label>
                    {this.cikkValaszto()}
                  </div>
                </div>
                <div className="col-md-2">
                  <div>
                    <Label for="cikk">Áfa (%):</Label>
                    <RFField
                      name="afa"
                      id="afa"
                      disabled
                      value={this.state.cikk ? this.state.cikk.afa : '0'}
                    />
                  </div>
                </div>
              </div>
              <Label for="azonosito">Azonosító: *</Label>
              <RFField
                name="azonosito"
                id="azonosito"
                // validate={{
                //   maxLength: { value: 15 }
                // }}
                maxLength={15}
                value={this.state.formTermekAzonosito === null ? '' : this.state.formTermekAzonosito}
                required
              />
            </div>
            <div>
              <Label for="rovidnev">Megjelenített név: *</Label>
              <RFField
                name="rovidnev"
                id="rovidnev"
                // validate={{
                //   maxLength: { value: 15 }
                // }}
                maxLength={20}
                value={this.state.formTermekNev === null ? '' : this.state.formTermekNev}
                required
              />
            </div>
            <SlaveAvInput
              id="listaar"
              label="Listaár: *"
              // validate={{
              //   maxLength: { value: 7 }
              // }}
              maxLength={7}
              required
              szuroTipus={NumberFormatter.OSSZEG}
            />
            <div>
              <Label for="szinkod">Színválasztás*</Label>
              {this.szinValaszto()}
            </div>
        </RFForm>
        <Modal isOpen={this.state.modalKozosTermekTorles} toggle={this.toggleKozosTermekTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a terméket?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteKozosTermek}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleKozosTermekTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
          {/*
          LRT 17. pont
          <RFForm
            onSubmit={this.toggleKozosTermekModositConfirm}
            modalInsert
            title={'Termék módosítás'}
            tagProps={{ isOpen: this.state.modalKozosTermekModosit, toggle: this.toggleKozosTermekModosit, className: this.props.className, backdrop: 'static' }}
            footer={
              <>
                <Button className="btn-cursor-pointer" color="primary">Mentés</Button>
                {' '}
                <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleKozosTermekModosit}>Mégsem</Button>
              </>
            }
          >
          */}
        <RFForm 
          onSubmit={this.modifyKozosTermek}
          modalInsert
          title={'Termék módosítás'}
          tagProps={{ isOpen: this.state.modalKozosTermekModosit, toggle: this.toggleKozosTermekModosit, className: this.props.className, backdrop: 'static' }}
          footer={
            <>
              <Button className="btn-cursor-pointer" color="primary">Mentés</Button>
              {' '}
              <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleKozosTermekModosit}>Mégsem</Button>
            </>
          }
        >
          <div className="row">
            <div className="col-md-10">
              <div>
                <Label for="cikk">Cikk: *</Label>
                <RFField
                  name="cikk"
                  for="cikk"
                  value={this.state.cikk ? this.state.cikk.megnevezes + ' (' + this.state.cikk.cikkszam + ')' : ''}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-2">
              <div>
                <Label for="cikk">Áfa (%):</Label>
                <RFField
                  name="afa"
                  id="afa"
                  value={this.state.cikk && this.state.cikk.aktualisAfaErtek ? this.state.cikk.aktualisAfaErtek : ''}
                  disabled
                />
              </div>
            </div>
          </div>
          <div>
            <Label for="azonosito">Azonosító:</Label>
            <RFField
              name="azonosito"
              for="azonosito"
              value={this.state.kozosTermekModositObj.azonosito}
              disabled
            />
          </div>
          <div>
            <Label for="rovidnev">Megjelenített név: *</Label>
            <RFField
              name="rovidnev"
              id="rovidnev"
              value={this.state.kozosTermekModositObj.rovidnev}
              // validate={{
              //   maxLength: { value: 15 }
              // }}
              maxLength={20}
              required
            />
          </div>
          <SlaveAvInput
            id="listaar"
            label="Listaár: *"
            value={this.state.kozosTermekModositObj.listaar}
            // validate={{
            //   maxLength: { value: 7 }
            // }}
            maxLength={7}
            required
            szuroTipus={NumberFormatter.OSSZEG}
          />
          <div>
            <Label for="szinkod">Szín: *</Label>
            {this.szinValaszto()}
          </div>
        </RFForm>
        {/*
        LRT 17. pont
         <Modal isOpen={this.state.modalKozosTermekModositConfirm} toggle={this.toggleKozosTermekModositConfirm} className={this.props.className} backdrop="static">
          <ModalHeader>Módosítás</ModalHeader>
          <ModalBody>Szeretné átvezetni ezeket a változtatásokat a büfé kínálatán?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.modifyKozosTermek}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleKozosTermekModositConfirm}>Mégsem</Button>
          </ModalFooter>
        </Modal> */}
      </div>
    );
  }
}

export default KozosCsoportLista;
